module.exports = __webpack_public_path__ + "img/layer-mesh.10c7d35f.svg";